(function(){
    /* Model */
    var Showlist = Backbone.Model.extend({
	     urlRoot: APP_CONFIG.MEDIA_API_ROOT+"showlists/"
        ,parse:function(resp){
	        //single items return differently from the api than when they are in groups
            if(resp.results){
                resp = resp.results;    
            }
            /*
	           PT#151210999
	           It's easier to remove unavailable assets at this point than do it everywhere we try to use assets 
	         */
	        if(resp.assets){
	            var i = resp.assets.length;
	            while(i--){
		            if(resp.assets[i].status === "unavailable"){
			            resp.assets.splice(i,1)
		            }
	            }
            }
            return resp;
        }
    })
    
    /* Collection */
    var Showlists = Backbone.PageableCollection.extend({
        model  : Showlist,
        url    : function(){
	        return APP_CONFIG.MEDIA_API_ROOT+"showlists/";
        }
    })


/* 
    API

    Use: Backbone.Radio.channel('entities').request('shows')
    
    These return a promise, so you'll want to wrap them in a $.when or something. 
    e.g. 
    $.when( Backbone.Radio.channel('entities').request('shows') )
        .done(function(data){ 
            console.log('d',data) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');
    //get a single item
    api.reply('showlist',function(id){
        var defer = $.Deferred()
            ,item = new Showlist({'id':id})
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })
    
    //get a collection
    api.reply('showlists',function(opts){
        opts = opts || {};
        var defer = $.Deferred()
            ,item = new Showlists([],opts)
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })

})();